import React from "react";
import { ICountriesResponse } from "../../api/get/getCountries";
import getStates from "../../api/get/getStates";
import countriesWithoutPostalCodes from "../constants/rawPostalCodeData";

export const parseAndSetStatesInCountry = async (
  countries: ICountriesResponse[],
  targetCountry: string,
  userToken: string,
  setStates: React.Dispatch<React.SetStateAction<any>>
) => {
  const countryRes = countries.find(({ country }) => country === targetCountry);
  if (countryRes) {
    setStates((prev: any) => ({
      ...prev,
      isLoading: true,
    }));

    const statesRes = await getStates(userToken, parseInt(countryRes.id, 10));
    if (statesRes) {
      setStates({
        data: statesRes.data,
        isLoading: false,
      });
    }
  }
};

export const parsePostalCodeRequirement = (
  countries: ICountriesResponse[],
  targetCountry: string,
  setPostalCode: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const countryRes = countries.find(({ country }) => country === targetCountry);
  if (countryRes?.ISOCode) {
    setPostalCode(
      !countriesWithoutPostalCodes.some(
        (ISOCode) => ISOCode === countryRes?.ISOCode
      )
    );
  }
};

export const getIsZipCodeRequired = (targetCountry: string) =>
  !countriesWithoutPostalCodes.some((ISOCode) => ISOCode === targetCountry);
